export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img2-a952a17bc972f30560b4c3f42833e6b2.png";